import { AddToHistory } from "./types";
import * as uuid from 'uuid';
import { PlayerCache } from "./PlayerCache";
import { PlaybackManager } from ".";
var uuidv4 = uuid.v4;
/**
 * This class manages playback of a list of media items
 */
var DynamicPlaylist = /** @class */ (function () {
    /**
     * Instantiates a new Playlist with an array of media items and a configuration
     * @param media
     * @param config
     * @param context Context is used for global identification of linked lists
     * @param queued Defines if this is a queue list or a normal list
     */
    function DynamicPlaylist(media, config, context, queued) {
        if (config === void 0) { config = {
            history_mode: AddToHistory.ALL
        }; }
        this.onChangedHandlers = {};
        this.context = context;
        this.internalList = media;
        this.queued = queued;
        this.config = config;
        this.cache();
    }
    DynamicPlaylist.prototype.cache = function () {
        this.internalList.forEach(function (media) {
            if (media.sound.file_url) {
                var url = PlaybackManager.getTrackUrl(media.sound, false).url;
                if (url)
                    PlayerCache.loadURL(url);
            }
        });
    };
    // - Data Management
    /**
     * Removes a track from the list
     * @param track
     */
    DynamicPlaylist.prototype.pop = function (track) {
        if (track) {
            var index = this.internalList.findIndex(function (obj1) {
                return track.sound.id === obj1.sound.id;
            });
            if (index !== -1) {
                this.internalList.splice(index, 1);
            }
        }
        else {
            this.internalList.pop();
        }
        this.callChangeHandlers(this);
    };
    /**
     * Adds tracks to the list
     * @param media
     */
    DynamicPlaylist.prototype.appendTracks = function (media) {
        this.internalList = [].concat(this.internalList, media);
        this.cache();
        this.callChangeHandlers(this);
    };
    /**
     * Replaces all tracks in the list
     * @param media
     */
    DynamicPlaylist.prototype.replace = function (media) {
        this.internalList = [].concat(media);
        this.cache();
        this.callChangeHandlers(this);
    };
    /**
     * Adds tracks to the start of the list
     * @param media
     */
    DynamicPlaylist.prototype.prependTracks = function (media) {
        this.internalList = [].concat(media, this.internalList);
        this.cache();
        this.callChangeHandlers(this);
    };
    /**
     * Returns the list of tracks
     */
    DynamicPlaylist.prototype.tracks = function () {
        var _this = this;
        return [].concat(this.internalList).map(function (track) {
            return Object.assign({}, track, { playlist: _this });
        });
    };
    // - Getters
    /**
     * Compares two DynamicPlaylists taking into account their context
     * @param toList
     */
    DynamicPlaylist.prototype.isEqual = function (toList) {
        if (toList === this) {
            return true;
        }
        if (this.context || toList.context) {
            return this.context === toList.context;
        }
        return false;
    };
    /**
     * Returns the history mode configuration
     */
    DynamicPlaylist.prototype.historyMode = function () {
        return this.config.history_mode;
    };
    /**
     * Returns the queue mode configuration
     */
    DynamicPlaylist.prototype.queueMode = function () {
        return this.queued;
    };
    // - Change Handlers
    /**
     * Registers a handler for changes in the internal track list
     * @param handler
     */
    DynamicPlaylist.prototype.addChangeHandler = function (handler) {
        var id = uuidv4();
        this.onChangedHandlers[id] = handler;
        return id;
    };
    /**
     * Removes a track list change handler
     * @param id
     */
    DynamicPlaylist.prototype.removeChangeHandler = function (id) {
        delete this.onChangedHandlers[id];
    };
    DynamicPlaylist.prototype.callChangeHandlers = function (content) {
        var _this = this;
        Object.keys(this.onChangedHandlers).map(function (key) { return _this.onChangedHandlers[key]; }).forEach(function (cb) {
            cb(content);
        });
    };
    return DynamicPlaylist;
}());
export default DynamicPlaylist;
//# sourceMappingURL=DynamicPlaylist.js.map